// https://gist.github.com/raphael-leger/4d703dea6c845788ff9eb36142374bdb#file-lazywithretry-js
import { lazy, LazyExoticComponent } from "react";

// this was created due to a chunk load error issue, read more here https://rollbar.com/blog/javascript-chunk-load-error/
export const lazyWithRetry = (
  componentImport: () => Promise<any>,
  namedExport: string
): LazyExoticComponent<any> =>
  // @ts-ignore
  lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window?.localStorage?.getItem("page-has-been-force-refreshed") || "false"
    );

    try {
      const component = await componentImport();

      window?.localStorage?.setItem("page-has-been-force-refreshed", "false");

      return { default: component[namedExport] };
    } catch (error) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        // Assuming that the user is not on the latest version of the application.
        // Let's refresh the page immediately.
        window?.localStorage?.setItem("page-has-been-force-refreshed", "true");
        return window?.location?.reload();
      }

      // The page has already been reloaded
      // Assuming that user is already using the latest version of the application.
      // Let's let the application crash and raise the error.
      throw error;
    }
  });
